// strings -> ["a", "b", "c"]
// separator -> ", "
// lastSeparatorWord -> "and"
// result -> "a, b and c"

interface JoinStringsWithSeparatorOptions {
  strings: string[];
  separator?: string;
  lastSeparatorWord?: string;
}

export const joinStringsWithSeparator = ({
  strings,
  separator = ', ',
  lastSeparatorWord,
}: JoinStringsWithSeparatorOptions): string => {
  if (strings.length <= 1) {
    return strings?.[0] ?? '';
  }

  if (!lastSeparatorWord) {
    return strings.join(separator);
  }

  const lastIndex = strings.length - 1;
  const firstPart = strings.slice(0, lastIndex).join(separator);
  const secondPart = ` ${lastSeparatorWord} ${strings[lastIndex]}`;
  return `${firstPart}${secondPart}`;
};
